import React from "react";

const CirclesWhite = () => (
  <svg
    width={1270.69}
    height={645.61}
    viewBox="0 0 1270.69 645.61"
    overflow="visible"
  >
    <style>
      {
        ".circlesWhite__st0{stroke-width:4}.circlesWhite__st0,.circlesWhite__st1{fill:none;stroke:#fff;stroke-miterlimit:10}"
      }
    </style>
    <g className="itemTo bounce2">
      <circle className="circlesWhite__st1" cx={952.4} cy={202.39} r={201.88} />
      <path
        className="circlesWhite__st0 drawIn3"
        d="M955.52 381.91c37.34-.62 74.81-12.86 106.64-37.45 78.47-60.62 92.94-173.38 32.31-251.85S921.1-.32 842.63 60.3c-35.44 27.38-57.82 65.39-66.13 106.07"
      />
      <path
        className="circlesWhite__st0 drawIn3"
        d="M956.07 362.03c32.92-.73 65.9-11.61 93.95-33.29 69.79-53.92 82.65-154.2 28.74-223.98-49.86-64.53-139.36-80.39-207.73-39.79"
      />
      <path
        className="circlesWhite__st0 drawIn3"
        d="M955.54 340.9c28.57-.63 57.2-10.07 81.55-28.88 60.55-46.78 71.71-133.78 24.93-194.33-23.39-30.27-56.83-48.2-92-52.71"
      />
      <path
        className="circlesWhite__st0 drawIn3"
        d="M956.8 319.49c23.59-.87 47.13-8.85 67.23-24.38 43.98-33.98 57.16-93.05 34.94-141.5"
      />
    </g>
    <g className="itemTo bounce2" style={{ animationDelay: `1s` }}>
      <circle
        className="circlesWhite__st1"
        cx={583.03}
        cy={153.62}
        r={129.96}
      />
      <path
        className="circlesWhite__st0 drawIn3"
        d="M586.62 268.91c23.77-.53 47.59-8.39 67.85-24.04 50.4-38.94 59.69-111.36 20.75-161.75-36-46.6-100.64-58.06-150.02-28.73"
      />
      <path
        className="circlesWhite__st0 drawIn3"
        d="M586.23 253.65c20.63-.45 41.31-7.27 58.89-20.86 43.72-33.78 51.79-96.61 18.01-140.34-16.89-21.86-41.04-34.81-66.44-38.07"
      />
      <path
        className="circlesWhite__st0 drawIn3"
        d="M587.14 238.19c17.03-.63 34.04-6.39 48.55-17.6 31.76-24.54 41.28-67.2 25.23-102.18"
      />
    </g>
    <g>
      <path
        className="circlesWhite__st1 drawIn3"
        style={{ animationDelay: `1s` }}
        d="M.25 630.75c.81-.46 239.66 76.12 458.97-119.78 150-133.98 282.46-116.89 427.3-32.67 115.63 67.23 283.78 76.8 383.84 23.14"
      />
      <path
        className="circlesWhite__st1 drawIn3"
        style={{ animationDelay: `2s` }}
        d="M.25 630.75s219.85 67.9 436.7-136.85c132.65-125.25 283.42-111.02 427.61-26.65 115.36 67.49 305.74 67.97 405.8 14.31"
      />
      <path
        className="circlesWhite__st1 drawIn3"
        style={{ animationDelay: `3s` }}
        d="M.25 630.75s195.38 60.39 420.64-156.58c130.89-126.08 295.73-95.69 437.82-10.27 114.15 68.63 311.6 51.58 411.66-2.08"
      />
      <path
        className="circlesWhite__st1 drawIn3"
        style={{ animationDelay: `4s` }}
        d="M.25 630.75s189.94 42.27 405.17-173c134.85-134.86 304.28-83.12 446.36 2.3 114.15 68.63 318.52 36.24 418.58-17.42"
      />
      <path
        className="circlesWhite__st1 drawIn3"
        style={{ animationDelay: `5s` }}
        d="M.25 630.75s169.9 31.86 375.06-178.37c148.03-151.69 325.1-87.18 469.47 4.29 111.74 70.8 363.61 17.85 425.59-37.57"
      />
      <path
        className="circlesWhite__st1 drawIn3"
        style={{ animationDelay: `6s` }}
        d="M.25 630.05s157.44 21.68 362.18-197.69c144.83-155.18 337.97-67.86 482.34 23.6 111.74 70.8 363.61-3.41 425.59-58.84"
      />
    </g>
  </svg>
);

export default CirclesWhite;
